<template>
  <v-card class="manage-lessons">
    <div class="band">
      <v-btn
        fab
        small
        color="white"
        outlined
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon dark>close</v-icon>
      </v-btn>
    </div>
    <v-row class="pa-3" v-if="selectedLessons && lessons">
      <v-col
        v-for="(lesson, index) in lessons"
        :key="index"
        lg="4"
        md="6"
        cols="12"
      >
        <lesson-card
          @toggleLessonSelect="toggleLessonSelect"
          @startClassLesson="startClassLesson"
          :lesson="lesson"
          :initSelected="selectedLessons.some(l => l.id === lesson.id)"
        ></lesson-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import LessonCard from '@/modules/lesson/views/LessonCard'
import Lesson from '@/modules/lesson/models/Lesson'
import Class from '@/modules/class/models/Class'
import { mapMutations } from 'vuex'

export default {
  name: 'ManageLesson',
  components: {
    LessonCard
  },
  props: {
    currentClassId: {
      type: String,
      require: false
    },
    selectedLessons: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      newClass: false
    }
  },
  computed: {
    lessons() {
      return Lesson.all()
    }
  },
  async mounted() {},
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async toggleLessonSelect(isSelected, lessonId) {
      const payload = {
        custom_class_id: this.currentClassId,
        isSelected: isSelected,
        lessonId: lessonId,
        module: 'teacher'
      }

      try {
        await Class.dispatch('toggleLessons', { payload: payload })
        if (isSelected) {
          this.showSnackbar('Lesson selected.')
        } else {
          this.showSnackbar('Lesson deselected.')
        }
      } catch (error) {
        this.showErrorSnackbar('There were an error. Please try again')
      }
    },
    async startClassLesson(lesson) {
      let slug = lesson.slug
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = 'lessons/teacher'
      } else {
        base_url = `${process.env.VUE_APP_LESSON}/teacher`
      }

      window.open(`${base_url}/${link}?slug=${slug}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.manage-lessons {
  box-shadow: none;
}
</style>
